import { Component, OnInit } from '@angular/core';
import { ECRService } from '../service/ecr.service';
import { CrudService } from '../service/crud.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.css']
})

export class EmailConfigurationComponent implements OnInit {
  SBU: string = "";
  sbuList: any;
  userId: any = '';
  department: any = '';
  deptList: any[] = [];
  selectedSbu = [];
  selectedDepartment = [];
  selectedEmployee = [];
  public empList = [];

  leaderList: any[];
  leaderEmail: any = '';

  empTmc: any = '';
  configList: any[] = [];
  p: number = 1;
  constructor(private _ecrService: ECRService, private _crudService: CrudService, private _sharedService: SharedService) {
    this.userId = sessionStorage.getItem("userId")
  }

  ngOnInit() {
    this.getBuWiseHRList();
    this.getConfigList();
  }

  getBuWiseHRList() {
    this._ecrService.getBuWiseHR(this.userId).subscribe((data: any) => {
      this.sbuList = data.Data;
    })
  }

  getDeptList(sbu) {
    this._ecrService.getDeptList(sbu).subscribe(data => {
      console.log(data);
      this.deptList = data.map(d => d['department']);
      this.deptList.sort((a, b) => a.localeCompare(b));
    })
  }

  deptChangeHandler(event) {
    this.selectedDepartment = event.map(c => c);
    const sbuName = this.selectedSbu;
    if (event.length > 0) {
      this.getEmpList(this.SBU, this.selectedDepartment);
    } else {
      this.empList = [];
    }
  }

  getEmpList(sbu, department) {
    this._ecrService.getEmpList(sbu, department).subscribe(data => {
      console.log(data);

      // Map the data and filter out entries where employee_name and tmc_id are both "ALL"
      this.empList = data
        .filter(employee => !(employee.employee_name === "ALL" && employee.tmc_id === "ALL"))
        .map(employee => {
          return {
            employee: `${employee.employee_name} - ${employee.tmc_id}`,
            tmcId: employee.tmc_id
          };
        });
    });
  }


  fetchCCList() {
    let formdata = new FormData();
    formdata.append("bucode", this.SBU);
    this._crudService.post(`Master/GetLeaderEmailId`, formdata).subscribe((data: any) => {
      this.leaderList = data.Data;
    })
  }

  getConfigList() {
    this._crudService.get(`Master/GetCCConfigList`).subscribe((data: any) => {
      this.configList = data.Data;
    })
  }


  submit() {
    let fd = new FormData();
    fd.append("BUSSINESS_UNIT", this.SBU);
    fd.append("DEPARTMENT", this.department);
    fd.append("EMP_TMC", this.empTmc);
    fd.append("CCEMAIL", this.leaderEmail);
    this._crudService.post(`Master/SaveCCEmailConfig`, fd).subscribe((res: any) => {
      console.log(res);
      if (res.Status) {
        this._sharedService.SwalSuccessMsg(res.Message);
        this.getConfigList();
        this.reset();
      } else {
        this._sharedService.SwalErrorMsg(res.Message);
      }
    })
  }

  reset() {
    this.SBU = '';
    this.department = '';
    this.empTmc = '';
    this.leaderEmail = '';
    this.empList = [];
    this.leaderList = [];
    this.deptList = [];
  }

  InActiveConfigList(item: any) {
    let fd = new FormData();
    fd.append("tmcNo", item.EMP_TMC);
    fd.append("ccEmail", item.CCEMAIL);
    this._crudService.post(`Master/InActiveConfigList`, fd).subscribe((res: any) => {
      if (res.Status) {
        this._sharedService.SwalSuccessMsg(res.Message);
        this.getConfigList();
      } else {
        this._sharedService.SwalErrorMsg(res.Message);
      }
    })
  }

  onPageChange(e: any) {
    this.p = e;
  }

}
